import React, { Component } from "react";
import { If } from "react-extras";
import get from "lodash/get";
import isEmpty from "lodash/isEmpty";
import { aggregateStats } from "../../lib/stats/utils";
import StatsPageTable from "./stats_page_table";
const columnInfo = [
  {
    accessor: "title",
    Header: "Episode Title",
  },
  {
    id: "count",
    accessor: "count",
    Header: "Downloads",
    Cell: ({ row }) => (row.count || 0).toLocaleString(),
  },
];
class StatsEpisodeTable extends Component {
  render() {
    var needsShow = !this.props.showUUID;
    var loadingEpisodes = !needsShow && !this.props.episodesByShow;
    var hasData = get(this.props, ["episodesByShow", this.props.showUUID], false);
    return (
      <div className="stats-table">
        <If condition={needsShow}>
          <div className="stats-table__select-show-message">
            <h3>Select a podcast from the filters above to view stats for its episodes.</h3>
          </div>
        </If>
        <If condition={!!loadingEpisodes}>
          <h3>Loading...</h3>
        </If>
        <If condition={hasData && Boolean(get(this.props.shows, [this.props.showUUID]))}>
          <h3>Downloads For {get(this.props.shows, [this.props.showUUID, "title"])}</h3>
          <StatsPageTable data={this.getData()} columns={columnInfo} />
        </If>
      </div>
    );
  }

  getData = () => {
    var data = aggregateStats(this.props.data, {});
    var episodes = get(this.props, ["episodesByShow", this.props.showUUID, "episodes"]);
    if (isEmpty(episodes)) {
      return [];
    }
    return Object.keys(episodes)
      .map(uuid => {
        var episode = episodes[uuid];
        return {
          title: episode.title,
          season: episode.season,
          episodeNumber: episode.episodeNumber,
          count: get(data, [uuid, "count"], 0),
        };
      })
      .reverse();
  };
}

export default StatsEpisodeTable;
